function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Newsletter Landing Page Scripts
 */

// Selectors
export var NEWSLETTER_FORM = '[data-newsletter-form]';
export var NEWSLETTER_FORM_FIELD = '[data-newsletter-form-field]';
export var NEWSLETTER_FORM_SUBMIT = '[data-newsletter-form-submit]';

// Classes
export var IS_HIDDEN = 'is-hidden';
var NewsletterForm = /*#__PURE__*/function () {
  function NewsletterForm(container) {
    _classCallCheck(this, NewsletterForm);
    this.container = container;
    this.newsletterFormSubmit = this.container.find(NEWSLETTER_FORM_SUBMIT);
    this.initKlaviyoNewsletterForm();
  }
  _createClass(NewsletterForm, [{
    key: "initKlaviyoNewsletterForm",
    value: function initKlaviyoNewsletterForm() {
      var newsletterFormField = this.container.find(NEWSLETTER_FORM_FIELD);
      KlaviyoSubscribe.attachToForms('#email_signup', {
        success: function success() {
          newsletterFormField.addClass(IS_HIDDEN);
        }
      });
    }
  }]);
  return NewsletterForm;
}();
$(document).ready($(NEWSLETTER_FORM).each(function (e, i) {
  return new NewsletterForm($(i));
}));